import { Component } from '@angular/core';

@Component({
  selector: 'app-check-example-dialogue',
  templateUrl: './check-example.dialogue.html',
})
export class CheckExampleDialogue {}
